import { isAfter, parseISO } from 'date-fns';

export const getIsAtRisk = ({
  latestFinish,
  planEndDate,
}: {
  latestFinish: string;
  planEndDate: string;
}) => {
  const latestFinishIso = parseISO(latestFinish);
  const planEnd = parseISO(planEndDate);

  return isAfter(latestFinishIso, planEnd);
};
